var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstructor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.162,
    height: 36.929,
    viewBox: "0 0 46.162 36.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chalkboard-teacher",
    "data-name": "Icon awesome-chalkboard-teacher",
    d: "M15,25.389a1.65,1.65,0,0,0-.509.079,9.515,9.515,0,0,1-2.953.5,9.523,9.523,0,0,1-2.954-.5,1.646,1.646,0,0,0-.509-.079A8.079,8.079,0,0,0,0,33.512a3.453,3.453,0,0,0,3.462,3.417H19.619a3.453,3.453,0,0,0,3.462-3.417A8.079,8.079,0,0,0,15,25.389ZM11.54,23.081a6.924,6.924,0,1,0-6.924-6.924A6.924,6.924,0,0,0,11.54,23.081ZM42.7,0H15A3.525,3.525,0,0,0,11.54,3.577V6.924a9.128,9.128,0,0,1,4.616,1.284V4.616H41.546V25.389H36.929V20.773H27.7v4.616H22.2a9.193,9.193,0,0,1,2.863,4.616H42.7a3.525,3.525,0,0,0,3.462-3.577V3.577A3.525,3.525,0,0,0,42.7,0Z",
    transform: "translate(0)",
    fill: "#a1a3ef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_189",
    "data-name": "Mask Group 189",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG",
    d: "M30,0H64.3a4,4,0,0,1,4,4V33.084a30,30,0,0,1-30,30H4a4,4,0,0,1-4-4V30A30,30,0,0,1,30,0Z",
    transform: "translate(-9.073 -10.767)",
    fill: "#a1a3ef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructor);
export default __webpack_public_path__ + "static/media/Instructor.2e499a23f6569aa2b00147795f22aa99.svg";
export { ForwardRef as ReactComponent };